module.exports = __webpack_public_path__ + "static/media/sos.9a6908f3.png";